import React from 'react';
import * as S from './HolidayCalenderLoader.styles';

const HolidayCalenderLoader = () => (
  <S.HolidayCalenderWrapper>
    <S.HolidayCalenderHeader />
    <S.HolidayCalenderListWrap>
      <S.HolidayListItem>
        <S.HolidayListDate />
        <S.HolidayListFestival />
      </S.HolidayListItem>
      <S.HolidayListItem>
        <S.HolidayListDate />
        <S.HolidayListFestival />
      </S.HolidayListItem>
      <S.HolidayListItem>
        <S.HolidayListDate />
        <S.HolidayListFestival />
      </S.HolidayListItem>
      <S.HolidayListItem>
        <S.HolidayListDate />
        <S.HolidayListFestival />
      </S.HolidayListItem>
      <S.HolidayListItem>
        <S.HolidayListDate />
        <S.HolidayListFestival />
      </S.HolidayListItem>
      <S.HolidayListItem>
        <S.HolidayListDate />
        <S.HolidayListFestival />
      </S.HolidayListItem>
    </S.HolidayCalenderListWrap>
  </S.HolidayCalenderWrapper>
);

export default HolidayCalenderLoader;
